<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import AccountDetails from "@retailer/svelte/Cart/Page/DistributorSection/ConfirmAccountDetails/AccountDetails.svelte";
  import EditAccountDetails from "@retailer/svelte/Cart/Page/DistributorSection/ConfirmAccountDetails/EditAccountDetails.svelte";

  export let salesRepNames: string[];
  export let distributorName: string;
  export let accountNumber: string;
  export let distributorAccount: {
    city: string;
    state: string;
    zip: string;
    address1: string;
    address2: string;
    address3: string;
  };
  export let onClose: () => void;
  export let onConfirm: () => void;
  export let handleEditEvent = () => {};
  export let onChangeAccountNumber: (newAccountNumber: string) => Promise<{ error?: string }>;

  let editingAccountNumber: boolean = false;

  const onCloseModal = () => {
    editingAccountNumber = false;
    onClose();
  };

  const onEdit = () => {
    editingAccountNumber = true;
    handleEditEvent();
  };

  const onLeaveEditMode = () => {
    editingAccountNumber = false;
  };

</script>

<Modal show={true} closeOnBackgroundClick={false} fizzModal={true} size={"medium"}>
  <section data-testid="confirm-account-details-modal">
    <header class="fizz-inset-square-16 fizz-space-between">
      <h4 class="fizz-heading-4">Confirm account details</h4>
      <button
        class="fizz-icon-button-small"
        data-testid="close-confirm-account-details-modal"
        on:click={onCloseModal}
      >
        <Icon type="X" />
      </button>
    </header>
    <div class="fizz-inset-horizontal-16 fizz-stack-24 fizz-text-left fizz-text-medium">
      <span>We found your account for</span>
      <span class="fizz-text-strong">{distributorName}.</span>
      <span>Confirm your details are correct to ensure accurate order deliveries.</span>
    </div>
    <div class="fizz-inset-horizontal-16 fizz-stack-16">
      <div class="fizz-inset-square-16 fizz-bordered fizz-text-left fizz-text-medium fizz-flow-8">
        {#if editingAccountNumber}
          <EditAccountDetails {onLeaveEditMode} onSubmit={onChangeAccountNumber} />
        {:else}
          <AccountDetails {salesRepNames} {accountNumber} {distributorAccount} />
        {/if}
      </div>
    </div>
    <footer class="fizz-flex-row fizz-justify-end fizz-inset-horizontal-16 fizz-stack-16">
      <button
        class="fizz-button"
        data-testid="edit-account-details"
        on:click={onEdit}
        disabled={editingAccountNumber}
      >
        Edit
      </button>
      <button
        class="fizz-button-secondary fizz-button"
        data-testid="confirm-account-details"
        on:click={onConfirm}
        disabled={editingAccountNumber}
      >
        Confirm
      </button>
    </footer>
  </section>
</Modal>
